import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  ADD_TOOLBAR_INSTANCE,
  CLEAR_CURRENT_TOOLBAR,
  DELETE_TOOLBAR_INSTANCE,
  FETCH_TOOLBAR_INSTANCES,
  SET_CURRENT_TOOLBAR,
  UPDATE_TOOLBAR_INSTANCE
} from './actionTypes'

export const fetchToolbarInstances = (): AppThunk => {
  return dispatch =>
    dispatch(
      request('/organizations/:organizationId/apiconnectors?type=toolbar', FETCH_TOOLBAR_INSTANCES, { method: 'GET' })
    )
}
export const createToolbarInstance = ({ name, description }: { name: string; description: string }): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        '/organizations/:organizationId/apiconnectors',
        ADD_TOOLBAR_INSTANCE,
        {
          method: 'POST',
          body: { type: 'toolbar', name, description }
        },
        { args: { name, description } }
      )
    )
  }
}

export const deleteToolbarInstance = (toolbarId: string): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/organizations/:organizationId/apiconnectors/${toolbarId}`,
        DELETE_TOOLBAR_INSTANCE,
        { method: 'DELETE' },
        { args: { toolbarId } }
      )
    )
}

export const updateToolbarInstance = ({
  name,
  description,
  id
}: {
  id: string
  name: string
  description: string
}): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/organizations/:organizationId/apiconnectors/${id}`,
        UPDATE_TOOLBAR_INSTANCE,
        {
          method: 'PUT',
          body: { name, description }
        },
        { args: { id, name, description } }
      )
    )
}

export function setCurrentToolbar(toolbar: unknown): AppThunk {
  return dispatch => {
    dispatch(createAction(SET_CURRENT_TOOLBAR, { toolbar }))
  }
}

export function clearCurrentToolbar(): AppThunk {
  return dispatch => {
    dispatch(createAction(CLEAR_CURRENT_TOOLBAR))
  }
}
